var map = {
	"./0.png": 34,
	"./1.png": 35,
	"./2.png": 36,
	"./3.png": 37,
	"./4.png": 38,
	"./5.png": 39,
	"./6.png": 40,
	"./Words3.png": 59,
	"./avitar.png": 30,
	"./back/0.png": 60,
	"./back/1.png": 61,
	"./front/0.png": 62,
	"./front/1.png": 63,
	"./front/2.png": 64,
	"./full/0.png": 65,
	"./full/1.png": 66,
	"./wordcloud.png": 67,
	"./words.png": 68,
	"./words2.png": 69,
	"./words4.png": 70,
	"./words5.png": 71,
	"./words6.png": 72,
	"./words7.png": 73,
	"./words8.png": 74,
	"./words9.png": 41
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;